import { HttpBackend } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { Config } from './conf';
import { ConfigService } from './config.service';

export function initializeConfigService(configService: ConfigService) {
    const res = () => configService.load();
    return res;
}

@NgModule({
    imports: [],
    declarations: [],
    providers: []
})
export class ConfigModule {
    static forRoot(config: Config = new Config()): ModuleWithProviders<ConfigModule> {
        return {
            ngModule: ConfigModule,
            providers: [
                { provide: Config, useValue: config },
                ConfigService,
                { provide: APP_INITIALIZER, useFactory: initializeConfigService, deps: [ConfigService, Config, HttpBackend], multi: true }
            ]
        };
    }
}
